import type moment from "moment";

import { BTSelectItem, type IBaseEntity } from "types/apiResponse/apiResponse";
import { type POApprovalStatus } from "types/enum";

import { InactiveSubInviteEntity } from "commonComponents/entity/sub/InactiveSubInvite/InactiveSubInvite.types";
import { GridEntity } from "commonComponents/utilities/Grid/GridContainer.types";

import { type RecursiveUpdateTypes } from "entity/costCatalog/CostCatalog.types";

import type { default as PurchaseOrderListJson } from "./PurchaseOrderList.api.json";

export type PurchaseOrderListFormActions = "newPurchaseOrder" | "checkedAction" | undefined;

export enum PurchaseOrderMassActionType {
    Delete = 1,
    Release = 2,
    Unrelease = 3,
    MarkComplete = 4,
    AttachFiles = 5,
    BillingRemaining = 6,
    Approve = 7,
}

export const PurchaseOrderMassActionDescriptions = new Map<PurchaseOrderMassActionType, string>([
    [PurchaseOrderMassActionType.Delete, "Delete"],
    [PurchaseOrderMassActionType.Release, "Release"],
    [PurchaseOrderMassActionType.Unrelease, "Unrelease"],
    [PurchaseOrderMassActionType.MarkComplete, "Mark Complete"],
]);

export class PurchaseOrderGridEntity extends GridEntity {
    constructor(data: typeof PurchaseOrderListJson) {
        super(data);
        this.canPayOnline = data.canPayOnline;
        this.canPayInFull = data.canPayInFull;
        this.showAccountingReauthBanner = data.showAccountingReauthBanner;
        this.accountingReauthBannerMessage = data.accountingReauthBannerMessage;
        this.accountingReauthBannerTitle = data.accountingReauthBannerTitle;
        this.requireSignatureForApproval = data.requireSignatureForApproval;
    }

    canPayOnline: boolean;
    canPayInFull: boolean;
    showAccountingReauthBanner: boolean;
    accountingReauthBannerMessage: string;
    accountingReauthBannerTitle: string;
    requireSignatureForApproval: boolean;
}

export interface IPurchaseOrderMassRequest {
    selectedPurchaseOrders: IBaseEntity[];
}

export interface IPurchaseOrderMassUpdateStatusesRequest {
    selectedPurchaseOrders: IBaseEntity[];
    newStatus: POApprovalStatus;
    recursiveUpdateType?: RecursiveUpdateTypes;
    statusChangeComments?: string;
}

export class InactiveSubsInviteReponse {
    constructor(data: any) {
        this.invactiveSubsWithoutEmail = data.map((x: any) => new InactiveSubInviteEntity(x));
    }

    invactiveSubsWithoutEmail: InactiveSubInviteEntity[];
}

export interface IBulkMarkCompleteRequest {
    purchaseOrderIds: number[];
    comments: string;
}

export class BulkMarkCompleteResponse {
    constructor(data: any) {
        this.updatedCount = data.updatedCount;
    }

    updatedCount: number;
}

export interface ICopyPurchaseOrdersRequest {
    builderId: number;
    fromJobId: number;
    purchaseOrderIds: number[];
    exportToJobId: number;
    copyPayments: boolean;
    copyPODocs: boolean;
    newDeadlineDate?: moment.Moment;
}

export class CopyPurchaseOrdersResponse {
    constructor(data: any) {
        this.exportedPoIds = data.exportedPoIds;
        this.subsNotOnJobsite = data.subsNotOnJobsite.map((sub: any) => new BTSelectItem(sub));
        this.internalUsersNotOnJobsite = data.internalUsersNotOnJobsite.map(
            (user: any) => new BTSelectItem(user),
        );
    }

    exportedPoIds: number[];
    subsNotOnJobsite: BTSelectItem[];
    internalUsersNotOnJobsite: BTSelectItem[];
}

export enum PurchaseOrderTabTypes {
    PurchaseOrder = "1",
    Bill = "2",
}
